// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { installCsrfFetch } from './utils/csrfFetch';

// Attach X-CSRF-Token to every write request to our API, including legacy
// raw fetch() calls that don't go through ApiService.
installCsrfFetch();

// Performance monitoring (optional)
import reportWebVitals from './reportWebVitals';

// Find the root element
const container = document.getElementById('root');
const root = createRoot(container);

// Render the app
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
if (typeof reportWebVitals === 'function') {
  reportWebVitals();
}